import MainLayout from "../../../commons/layout/MainLayout";
import VideoComponentCustom from "../../../commons/components/Video";
import { useNavigate } from "react-router-dom";
import ROUTERS from "../../../commons/constans/router";
type Props = {
  footerShow: Boolean
}
const VideoComponent = ({footerShow}:Props) => {

  const navigate = useNavigate();
  const handleLeftClick = () => {
    navigate(ROUTERS.HOME);
  }

  return (
    <MainLayout
      pageClass = {'video-page'}
      handleLeftClick = {() => handleLeftClick()}
      footerShow={false}
      headerShow={false}
    >
      <VideoComponentCustom />
    </MainLayout>
  )
}

export default VideoComponent;